const _excluded = ["id", "name", "children", "bottomArea"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { Typography } from 'seagull';
import styles from "./PackageCard.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PackageCard(_ref) {
  let {
      id,
      name,
      children,
      bottomArea
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("li", {
    className: styles.packageCard,
    "data-testid": props['data-testid'],
    "data-bundleid": id,
    children: [/*#__PURE__*/_jsx(Typography, {
      className: styles.packageName,
      variant: "h5",
      "data-testid": props['data-testid'] + '-title',
      children: name
    }), /*#__PURE__*/_jsx("ul", {
      className: styles.sectionsList,
      children: children
    }), bottomArea]
  });
}